import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export class KeyOnlyTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    // Returns an empty object since keys are directly displayed
    return of({});
  }

  translateKey(key: string): string {
    return key; // Directly returns the key
  }
}
